<template>
  <div class="NewsDetails">
    <banner  />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <img :src="newsIdList.Img" alt />
        <p class="product-title">{{newsIdList.Title}}</p>
        <p class="product-time">{{newsIdList.CreateTime}}</p>
        <div class="product-content" v-if="newsIdList.ContentHtml" v-html="newsIdList.ContentHtml" style="font-size: 16px"></div>
<!--        <p class="product-content">{{newsIdList.Content}}</p>-->
        <div class="product-content" v-else style="font-size: 16px; text-align:justify;text-justify:distribute-all-lines;/*ie6-8*/;
  text-align-last:justify;/* ie9*/;-moz-text-align-last:justify;/*ff*/;-webkit-text-align-last:justify;/*chrome 20+*/">{{newsIdList.Content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {},
      newsList:[],
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
     this.newsList=this.$newsList;

     this.newsList.forEach(item=>{
       if (item.Id==this.pid){
         this.newsIdList=item;
         return ;

       }
     })
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>
